import React from 'react';
import './footer.less';

export default function Footer(props) {
  return (
    <>
      <div className="copy-right-container">
        <div className='logo'></div>
        <p>Copyright © {new Date().getFullYear()} JD.com 技术与数据中台-数据产品平台部版权所有</p>
        <p>咚咚答疑群：<a href='timline://chat/?topin=10204982304&type=2'>10204982304</a></p>
      </div>
    </>)
}